import { Modal, ModalBody, ModalTitle } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const DocumentTextModal = ({ content, onClose, title, }) => (React.createElement(Modal, { closeButton: true, onClose: onClose, show: true, size: "full-width" },
    React.createElement(ModalTitle, null, title),
    React.createElement(ModalBody, null, content)));
export default DocumentTextModal;
